import { useMemo } from "react";
import { Column, useTable } from "react-table";
import {
  IconButton,
  TextField,
  SelectField,
  SelectFieldOption,
} from "@funcional/react-ui";
import { IUser, IUserProfile, ISsoProfile } from "@sso/users/contracts";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { UseFormRegister } from "react-hook-form";
import { ReactTable } from "@funcional/react-table-ui";

interface UserProfileListProps {
  register: UseFormRegister<IUser>;
  addProfile: Function;
  deleteProfile: Function;
  data: IUserProfile[];
  errors: any;
  profiles: ISsoProfile[];
}

interface RangeWithErrors extends IUserProfile {
  errors?: any;
}

export const UserProfilesForm = ({
  register,
  addProfile,
  deleteProfile,
  data,
  errors,
  profiles,
}: UserProfileListProps) => {
  const preparedData = data.map((range, index) => ({
    ...range,
    errors: errors?.profiles?.[index],
  }));
  const columns: Column<RangeWithErrors>[] = useMemo(
    () =>
      [
        {
          Header: "Papel",
          accessor: "role",
          Cell: ({
            row: {
              index,
              original: { errors },
            },
            value,
          }: any) => (
            <SelectField
              required
              defaultValue={value || ""}
              errorMessage={errors?.role?.message}
              id="role"
              {...register(`profiles.${index}.role` as "profiles.0.role")}
              size="small"
              inputProps={{ style: { minWidth: "1em" } }}
              placeholder="Papel"
            >
              {profiles.map((item) => (
                <SelectFieldOption key={item.type} value={item.type}>
                  {item.description}
                </SelectFieldOption>
              ))}
            </SelectField>
          ),
        },
        {
          Header: "Identidade",
          accessor: "identity",
          Cell: ({
            row: {
              index,
              original: { role, errors },
            },
            value,
          }: any) => (
            <TextField
              defaultValue={value}
              errorMessage={errors?.identity?.message}
              {...register(
                `profiles.${index}.identity` as "profiles.0.identity"
              )}
              size="small"
              inputProps={{ style: { minWidth: "1em" } }}
              placeholder="CNPJ ou código ou etc."
            />
          ),
        },
      ] as Column<RangeWithErrors>[],
    [register]
  );

  const tableInstance = useTable(
    { columns, data: preparedData },
    (hooks: any) => {
      hooks.visibleColumns.push((columns: any) => [
        ...columns,
        {
          id: "crud",
          Header: () => (
            <IconButton
              size="small"
              title="Adicionar perfil"
              onClick={addProfile}
            >
              <AddIcon />
            </IconButton>
          ),
          Footer: () => (
            <IconButton
              size="small"
              title="Adicionar perfil"
              onClick={addProfile}
            >
              <AddIcon />
            </IconButton>
          ),
          Cell: ({ row }: any) => (
            <div className="flex">
              <IconButton
                size="small"
                title="Excluir"
                onClick={() => deleteProfile(row)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        },
      ]);
    }
  );

  return <ReactTable compact footer tableInstance={tableInstance} />;
};
